import './KensuTable.css';

import React from 'react';
import {Long} from "protobufjs";

type Props<T extends any> = {
  data: T[] | null | undefined,

  columns: ColumnDefinition<T>[]
  onRowSelected?: (row: T) => void;

  defaultSort?: KensuTableSort
}

export type KensuTableSort = {
  columnIndex: number,
  ascending: boolean,
}

export type ColumnDefinition<T> = {
  label: string,
  render: (row: T) => any,
  showArchivedBadge?: (row: T) => boolean | null | undefined,

  // Use this to specify a custom sort order; otherwise it'll use the rendered text,
  // whatever that turns out to be.
  sortOrder?: (row: T) => number | Long | null | undefined
  sortString?: (row: T) => string | null | undefined
}

export const KensuTable = <T extends any>(props: Props<T>) => {

  const [sortColumn, setSortColumn] = React.useState<ColumnDefinition<T> | undefined>(
      props.defaultSort && props.columns[props.defaultSort.columnIndex]
  );
  const [sortAscending, setSortAscending] = React.useState(props.defaultSort && props.defaultSort.ascending);

  const sort = (column: ColumnDefinition<T>) => {
    if (!column.sortString && !column.sortOrder) {
      // unsortable;
      return;
    }

    if (column == sortColumn) {
      setSortAscending(!sortAscending);
    } else {
      setSortColumn(column);
      setSortAscending(true);
    }
  }

  const sortedData = React.useMemo(() => {

    if (!props.data || !sortColumn) {
      return props.data;
    }

    // Default to the ascii string.
    if (sortColumn.sortOrder) {
      return [...props.data].sort((a, b) => {
        // @ts-ignore
        return (sortAscending ? 1 : -1) * (sortColumn.sortOrder(a) - sortColumn.sortOrder(b))
      });
    }

    if (sortColumn.sortString) {
      return [...props.data].sort((a, b) => {
        // @ts-ignore 
        const stringA = sortColumn.sortString(a) ?? '';
        // @ts-ignore
        const stringB = sortColumn.sortString(b) ?? '';
        return (sortAscending ? 1 : -1) * stringA?.localeCompare(stringB);
      });
    }

    return props.data;

  }, [props.data, sortColumn, sortAscending]);

  return <table className={'KensuTable'}>
    <thead>
    <tr>
      {props.columns.map(c => <th key={c.label} onClick={() => sort(c)}>{c.label}
        {c == sortColumn && (sortAscending ? '↑' : '↓')}
      </th>)}
    </tr>
    </thead>
    <tbody>
    {sortedData?.map((row, idx) => <tr key={`tr-${idx}`}>
      {props.columns.map(col =>
          <td key={col.label} onClick={() => props.onRowSelected && props.onRowSelected(row)}>
            {col.render(row)} {col.showArchivedBadge && col.showArchivedBadge(row) &&
              <span className={'Badge'}>ARCHIVED</span>}
          </td>)}
    </tr>)}
    </tbody>
  </table>;
}